/* ==========================================================================
   naturafit Landingpage
   Quick Add ohne Seitenwechsel.

   Ein einziger Listener am Dokument, deshalb funktioniert er fuer alle Karten
   in allen Abschnitten - auch fuer solche, die der Theme-Editor nachtraeglich
   neu rendert.
   ========================================================================== */

(function () {
  if (window.__nfCardAddInit) return;
  window.__nfCardAddInit = true;

  /* Warenkorb-Slider nach dem Hinzufuegen oeffnen?
     false = auf der Seite bleiben und weiter sammeln. */
  var OPEN_DRAWER = false;

  /* Routen aus dem Theme uebernehmen. Wichtig fuer weitere Sprachen und
     Maerkte, deren URLs ein Praefix tragen (z. B. /de/cart/add.js). */
  var routes = (window.theme && window.theme.routes && window.theme.routes.cart) || {};
  var ADD_URL = (routes.add || "/cart/add") + ".js";
  var CART_URL = (routes.base || "/cart") + ".js";

  function flash(button) {
    button.classList.add("is-added");
    setTimeout(function () {
      button.classList.remove("is-added");
    }, 1600);
  }

  /* Variantenwahl in den Highlight-Kacheln: die Radios waehlen die Variante
     bereits ohne JavaScript aus, hier wird nur der Preis mitgezogen. */
  document.addEventListener("change", function (event) {
    var radio = event.target.closest('.nf-duo__form input[name="id"]');
    if (!radio) return;

    var form = radio.closest(".nf-duo__form");
    var price = form.querySelector("[data-nf-duo-price]");
    if (price && radio.dataset.price) {
      price.textContent = radio.dataset.price;
    }
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest(".nf-card__form, .nf-duo__form");
    if (!form) return;

    /* Bei Radios zaehlt die ausgewaehlte Variante, sonst das versteckte Feld. */
    var input =
      form.querySelector('input[name="id"]:checked') ||
      form.querySelector('input[name="id"]');
    var button = form.querySelector(".nf-card__add, .nf-duo__add");
    if (!input || !button) return;

    event.preventDefault();

    if (button.disabled) return;
    button.disabled = true;

    fetch(ADD_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [{ id: Number(input.value), quantity: 1 }]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("add failed");
        return response.json();
      })
      .then(function () {
        flash(button);

        /* Stiletto hoert an Header und Warenkorb-Slider auf dieses Event und
           aktualisiert daraufhin Anzahl und Inhalt selbst. Es ist der vom
           Theme vorgesehene Andockpunkt fuer externen Code. */
        document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));

        /* Sicherheitsnetz, falls der Header das Event einmal verpasst. */
        return fetch(CART_URL, { credentials: "include" })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            document.querySelectorAll("[data-js-cart-count]").forEach(function (el) {
              el.innerHTML = cart.item_count;
            });
          });
      })
      .then(function () {
        if (!OPEN_DRAWER) return;

        /* Der Slider laesst sich nur ueber die theme-interne Ereignisleitung
           oeffnen. Von aussen erreichbar ist sie ueber das Warenkorb-Symbol
           im Header. Die Verzoegerung gibt dem Slider Zeit, sich vorher zu
           aktualisieren - so macht das Theme es an anderer Stelle auch. */
        setTimeout(function () {
          var icon = document.querySelector("[data-js-cart-icon]");
          if (icon) icon.click();
        }, 350);
      })
      .catch(function () {
        /* Notnagel: normal absenden, damit das Produkt trotzdem im Warenkorb
           landet - dann eben mit Seitenwechsel. */
        form.submit();
      })
      .finally(function () {
        button.disabled = false;
      });
  });
})();